import { render, staticRenderFns } from "./ImgResizePanel.vue?vue&type=template&id=bcbd999e&scoped=true&"
import script from "./ImgResizePanel.vue?vue&type=script&lang=js&"
export * from "./ImgResizePanel.vue?vue&type=script&lang=js&"
import style0 from "./ImgResizePanel.vue?vue&type=style&index=0&id=bcbd999e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbd999e",
  null
  
)

export default component.exports